export function init(name) {
    const playersItems = $(name);

    if (!playersItems.length) {
        return;
    }

    playersItems.each(function(i, $elem) {

        let players = window.players;
        let index = players.length;

        let currentPlayer = {
            'id': index+1,
            'player': null,
            'player2': null,
            'options': {},
            'prevVolume': 1,
            'videoType': getPlayerType($elem),
            'element': $elem
        };

        currentPlayer = initPlayers(currentPlayer);

        $($elem).data('player-vid-id', currentPlayer.id);
        $($elem).data('player-vid-type', currentPlayer.videoType);

        players[index] = currentPlayer;
        window.players = players;
    });
}

export function initClicks($name, $parentName) {
    if (!$($parentName).length) {
        return;
    }

    $($name+'-play').click(function (e) {
        e.preventDefault();

        const parent = $(this).parents($parentName);
        const type = parent.data('player-vid-type');
        const id = parent.data('player-vid-id');

        $(window).trigger('resize');

        if (type && id) {
            $(window).trigger('videoBanner:' + type + ':start', [id, $(this)]);
        }
    });

    $($name+'-stop').click(function (e) {
        e.preventDefault();

        const parent = $(this).parents($parentName);
        const type = parent.data('player-vid-type');
        const id = parent.data('player-vid-id');

        $(window).trigger('resize');

        if (type && id) {
            $(window).trigger('videoBanner:' + type + ':stop', [id, $(this)]);
        }
    });

    $($name+'-pause').click(function (e) {
        e.preventDefault();

        const elem = $(this);
        const parent = $(this).parents($parentName);
        const type = parent.data('player-vid-type');
        const id = parent.data('player-vid-id');

        $(window).trigger('resize');

        if (type && id) {
            elem.toggleClass('is-active');

            if (elem.hasClass('is-active')) {
                $(window).trigger('videoBanner:' + type + ':pause', [id, elem]);
            } else {
                $(window).trigger('videoBanner:' + type + ':start', [id, elem]);
            }
        }
    });

    $($name+'-sound').click(function (e) {
        e.preventDefault();

        const elem = $(this);
        const parent = elem.parents($parentName);
        const type = parent.data('player-vid-type');
        const id = parent.data('player-vid-id');

        if (elem.hasClass('is-active')) {
            elem.removeClass('is-active');
            $(window).trigger('videoBanner:' + type + ':stopSound', [id, elem]);
        } else {
            elem.addClass('is-active');
            $(window).trigger('videoBanner:' + type + ':startSound', [id, elem]);
        }
    });

    $($name+'-repeat').click(function (e) {
        e.preventDefault();

        const parent = $(this).parents($parentName);
        const type = parent.data('player-vid-type');
        const id = parent.data('player-vid-id');

        $(window).trigger('videoBanner:' + type + ':repeat', [id, $(this)]);
    });
}

export function initWindowClicks($parentName) {
    if (!$($parentName).length) {
        return;
    }

    YouTubeClicks();
    vimeoClicks();
}

//
//
//

function getPlayerType($elem) {
    return $($elem).find('.js-video-youtube').length ? 'youtube' : 'vimeo'
}

function initPlayers(currentPlayer) {
    return currentPlayer.videoType === 'youtube' ? initYouTubePlayer(currentPlayer) : initVimeoPlayer(currentPlayer);
}

function initYouTubePlayer(currentPlayer) {
    let $elem = currentPlayer.element;

    let tag = document.createElement('script');
    tag.src = "//www.youtube.com/iframe_api?origin=" + window.location.href;
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    let player = $($elem).find('.js-video-youtube');
    let body = $('body');

    currentPlayer.options = {
        ratio: 16 / 9,
        videoId: player.data('video'),
        videoId2: player.data('video-2'),
        videoTag: player.data('banner-video-tag'),
        videoLoopTag: player.data('banner-video-loop-tag'),
        autohide: 1,
        loop: 1,
        mute: false,
        repeat: true,
        width: $(window).width(),
        start: 0
    };

    let div = document.createElement("div");
    div.className += ' modal-movie modal-movie--sec';
    div.id = 'modal-movie-' + currentPlayer.options.videoId;
    div.innerHTML = "<div class='close | js-close-modal'><i class='icon icon-cancel'></i></div><div id='modal-video-youtube-" + currentPlayer.options.videoId + "'></div>";
    document.body.appendChild(div);

    let resizeVideo = function ($id) {
        let width = $(window).width(),
            pWidth,
            height = $($elem).hasClass('js-time-line-hld') ? $($elem).find('.js-time-line-hld-video').height() : $($elem).height(),
            pHeight,
            $tubularPlayer = $('#'+$id);

        if (width / currentPlayer.options.ratio < height) {
            pWidth = Math.ceil(height * currentPlayer.options.ratio);
            $tubularPlayer.width(pWidth).height(height).css({ left: (width - pWidth) / 2, top: 0 });
        } else {
            pHeight = Math.ceil(width / currentPlayer.options.ratio);
            $tubularPlayer.width(width).height(pHeight).css({ left: 0, top: (height - pHeight) / 2 });
        }

    };

    $(window).on('resize', function () {
        if (currentPlayer.options.videoId) {
            resizeVideo(currentPlayer.options.videoTag);
        }
        if (currentPlayer.options.videoId2 && $('body').hasClass('is-desktop')) {
            resizeVideo(currentPlayer.options.videoLoopTag);
        }
    });

    window.onYouTubeIframeAPIReady = function () {
        if (currentPlayer.options.videoId) {
            currentPlayer.player = new YT.Player('modal-video-youtube-' + currentPlayer.options.videoId, {
                width: $(window).width(),
                height: Math.ceil($(window).width() / currentPlayer.options.ratio),
                videoId: currentPlayer.options.videoId,
                playerVars: {
                    controls: 1,
                    showinfo: 0,
                    modestbranding: 1,
                    wmode: 'transparent',
                    cc_load_policy: 1,
                    disablekb: 1,
                    fs: 0,
                    iv_load_policy: 3,
                    rel: 0,
                    autohide: 1,
                    loop: 1,
                },
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });
        }

        if (currentPlayer.options.videoId2 && body.hasClass('is-desktop')) {
            currentPlayer.player2 = new YT.Player(currentPlayer.options.videoLoopTag, {
                width: currentPlayer.options.width,
                height: Math.ceil(currentPlayer.options.width / currentPlayer.options.ratio),
                videoId: currentPlayer.options.videoId2,
                playerVars: {
                    controls: 0,
                    showinfo: 0,
                    modestbranding: 1,
                    wmode: 'transparent',
                    cc_load_policy: 0,
                    disablekb: 1,
                    fs: 0,
                    iv_load_policy: 3,
                    rel: 0,
                    autohide: 1,
                    loop: 1,
                },
                events: {
                    'onReady': onPlayerReady2,
                    'onStateChange': onPlayerStateChange2
                }
            });
        }
    };

    window.onPlayerReady = function (e) {
        if (currentPlayer.options.mute) e.target.mute();
        e.target.seekTo(currentPlayer.options.start);
        e.target.pauseVideo();
    };

    if (currentPlayer.options.videoId2 && body.hasClass('is-desktop')) {
        window.onPlayerReady2 = function (e) {
            resizeVideo(currentPlayer.options.videoLoopTag);
            e.target.mute();
            e.target.seekTo(currentPlayer.options.start);
            e.target.playVideo();
        };
    }

    window.onPlayerStateChange = function (state) {

        if (state.data === YT.PlayerState.ENDED && $(window).width() < 800) {
            $(window).trigger('videoBanner:youtube:stop', currentPlayer.id);
        }

        if (state.data === 0 && currentPlayer.options.repeat) {
            currentPlayer.player.seekTo(options.start);
        }
    };

    if (currentPlayer.options.videoId2 && body.hasClass('is-desktop')) {
        window.onPlayerStateChange2 = function (state) {
            if (state.data === YT.PlayerState.ENDED) {
                currentPlayer.player2.seekTo(currentPlayer.options.start);
            }
        };
    }

    return currentPlayer;
}

function initVimeoPlayer(currentPlayer) {
    const $elem = currentPlayer.element;

    let tag = document.createElement('script');
    tag.src = "//player.vimeo.com/api/player.js?origin=" + window.location.href;

    if (tag.readyState) {
        tag.onreadystatechange = function () {
            if (tag.readyState === "loaded" || tag.readyState === "complete") {
                tag.onreadystatechange = null;
                loadPlayerLoop();
                loadPlayer();
            }
        };
    } else {
        tag.onload = function () {
            loadPlayerLoop();
            loadPlayer();
        };
    }

    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    let player = $($elem).find('.js-video-vimeo');
    const body = $('body');

    currentPlayer.options = {
        ratio: 16 / 9,
        videoId: player.data('video'),
        videoId2: player.data('video-2'),
        videoTag: "modal-video-vimeo-" + player.data('video'),
        videoLoopTag: player.data('banner-video-loop-tag'),
        mute: false,
        loop: true,
        width: $(window).width(),
        start: 0,
        playsinline: body.hasClass('is-desktop'),
    };

    let resizeVideo = function ($id) {
        let width = $(window).width(),
            pWidth,
            height = $($elem).hasClass('js-time-line-hld') ? $($elem).find('.js-time-line-hld-video').height() : $($elem).height(),
            pHeight,
            $tubularPlayer = $('#'+$id);

        if (width / currentPlayer.options.ratio < height) {
            pWidth = Math.ceil(height * currentPlayer.options.ratio);
            $tubularPlayer.width(pWidth).height(height).css({ left: (width - pWidth) / 2, top: 0 });
        } else {
            pHeight = Math.ceil(width / currentPlayer.options.ratio);
            $tubularPlayer.width(width).height(pHeight).css({ left: 0, top: (height - pHeight) / 2 });
        }

    };

    $(window).on('resize', function () {
        if (currentPlayer.options.videoId2 && body.hasClass('is-desktop')) {
            resizeVideo(currentPlayer.options.videoLoopTag);
        }
    });

    let div = document.createElement("div");
    div.className += ' modal-movie modal-movie--sec';
    div.id = 'modal-movie-' + currentPlayer.options.videoId;
    div.innerHTML = "<div class='close | js-close-modal'><i class='icon icon-cancel'></i></div><div id='modal-video-vimeo-" + currentPlayer.options.videoId + "'></div>";
    document.body.appendChild(div);

    let loadPlayer = function () {
        if (currentPlayer.options.videoId && !body.hasClass('is-desktop')) {
            currentPlayer.player = new Vimeo.Player(currentPlayer.options.videoTag, {
                id: currentPlayer.options.videoId,
                width: currentPlayer.options.width,
                height: Math.ceil(currentPlayer.options.width / currentPlayer.options.ratio),
                autoplay: false,
                background: false,
                loop: currentPlayer.options.loop,
                playsinline: body.hasClass('is-desktop'),
            });

            let videoHld = $($elem).find('.js-banner-video-play');

            currentPlayer.player.on('pause', function () {
                videoHld.removeClass('is-active');
                $($elem).removeClass('is-watching');
            });
        }
    };

    let loadPlayerLoop = function () {
        if (currentPlayer.options.videoId2 && body.hasClass('is-desktop')) {
            currentPlayer.player2 = new Vimeo.Player(currentPlayer.options.videoLoopTag, {
                id: currentPlayer.options.videoId2,
                width: currentPlayer.options.width,
                height: Math.ceil(currentPlayer.options.width / currentPlayer.options.ratio),
                autoplay: true,
                background: true,
                loop: true,
                playsinline: body.hasClass('is-desktop'),
            });

            resizeVideo(currentPlayer.options.videoLoopTag);

            currentPlayer.player2.on('loaded', function () {
                resizeVideo(currentPlayer.options.videoLoopTag);
                currentPlayer.player2.setCurrentTime(currentPlayer.options.start);
                currentPlayer.player2.setVolume(0);
            });
        }
    };

    return currentPlayer;
}

function YouTubeClicks() {

    $(window).on('videoBanner:youtube:start', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player2) {
            currentPlayer.player2.pauseVideo();
        }

        if (currentPlayer) {
            if ($('body').hasClass('is-desktop') || $('body').hasClass('android')) {
                let modal = $('#modal-movie-' + currentPlayer.options.videoId);

                modal.find('.js-close-modal').click(function (e) {
                    e.preventDefault();

                    currentPlayer.player.pauseVideo();

                    if (currentPlayer && currentPlayer.player2) {
                        currentPlayer.player2.mute();
                        currentPlayer.player2.playVideo();
                    }

                    modal.fadeOut();
                });

                modal.fadeIn(function() {
                    currentPlayer.player.playVideo();
                });
            } else {
                if (currentPlayer.player) {
                    currentPlayer.player.playVideo();
                }
            }
        }
    });

    $(window).on('videoBanner:youtube:stop', function (event, id, button) {
        let currentPlayer = players[id-1];

        if (currentPlayer) {
            let $elem = $(currentPlayer.element);
            if (button) {
                button.removeClass('is-active');
            }
            $elem.removeClass('is-watching');
            $elem.find('[class*="-pause"]').removeClass('is-active');

            if (currentPlayer.player) {
                currentPlayer.player.pauseVideo();
            }

            if (currentPlayer.player2) {
                currentPlayer.player2.mute();
                currentPlayer.player2.playVideo();
            }
        }
    });

    $(window).on('videoBanner:youtube:stopLoop', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer) {
            let $elem = $(currentPlayer.element);

            $elem.removeClass('is-watching');
            $elem.find('[class*="-pause"]').removeClass('is-active');

            if (currentPlayer.player) {
                currentPlayer.player.pauseVideo();
            }

            if (currentPlayer.player2) {
                currentPlayer.player2.pauseVideo();
            }
        }
    });

    $(window).on('videoBanner:youtube:startLoop', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player) {
            currentPlayer.player.mute();
        }

        if (currentPlayer && currentPlayer.player2) {
            currentPlayer.player2.mute();
            currentPlayer.player2.playVideo();
        }
    });

    $(window).on('videoBanner:youtube:pause', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player) {
            currentPlayer.player.pauseVideo();
        }
    });

    $(window).on('videoBanner:youtube:startSound', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player) {
            currentPlayer.player.unMute();
        }
    });

    $(window).on('videoBanner:youtube:stopSound', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player) {
            currentPlayer.player.mute();
        }
    });

    $(window).on('videoBanner:youtube:repeat', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player) {
            currentPlayer.player.seekTo(currentPlayer.options.start);
        }
    });
}

function vimeoClicks() {

    $(window).on('videoBanner:vimeo:start', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player2) {
            currentPlayer.player2.pause();
        }

        if ($('body').hasClass('is-desktop') || $('body').hasClass('android')) {
            let modal = $('#modal-movie-' + currentPlayer.options.videoId);

            if (!currentPlayer.player) {
                currentPlayer.player = new Vimeo.Player('modal-video-vimeo-' + currentPlayer.options.videoId, {
                    id: currentPlayer.options.videoId,
                    width: $(window).width(),
                    height: Math.ceil($(window).width() / currentPlayer.options.ratio),
                    autoplay: true,
                    background: false,
                    loop: currentPlayer.options.loop
                });

                currentPlayer.player.on('loaded', function () {
                    currentPlayer.player.setVolume(currentPlayer.prevVolume);
                });
            }

            modal.find('.js-close-modal').click(function (e) {
                e.preventDefault();

                currentPlayer.player.pause();

                if (currentPlayer && currentPlayer.player2) {
                    currentPlayer.player2.play();
                }

                modal.fadeOut();
            });

            modal.fadeIn(function() {
                currentPlayer.player.play();
            });
        } else {
            if (currentPlayer.player) {
                currentPlayer.player.play();
            }
        }
    });

    $(window).on('videoBanner:vimeo:stop', function (event, id, button) {
        let currentPlayer = players[id-1];

        if (!currentPlayer) {
            return;
        }

        if (button) {
            button.removeClass('is-active');
        }

        if (currentPlayer.player) {
            currentPlayer.player.pause();

            if ($('body').hasClass('is-desktop') || $('body').hasClass('android')) {
                let modal = $('#modal-movie-' + currentPlayer.options.videoId);

                modal.fadeOut();
            }
        }

        if (currentPlayer.player2) {
            currentPlayer.player2.setVolume(0);
            currentPlayer.player2.play();
        }
    });

    $(window).on('videoBanner:vimeo:stopLoop', function (event, id) {
        let currentPlayer = players[id-1];

        if (!currentPlayer) {
            return;
        }

        let $elem = $(currentPlayer.element);

        $elem.removeClass('is-watching');
        $elem.find('[class*="-pause"]').removeClass('is-active');

        if (currentPlayer.player) {
            currentPlayer.player.pause();
        }

        if (currentPlayer.player2) {
            currentPlayer.player2.pause();
        }
    });

    $(window).on('videoBanner:vimeo:startLoop', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer.player) {
            currentPlayer.player.setVolume(0);
        }

        if (currentPlayer.player2) {
            currentPlayer.player2.setVolume(0);
            currentPlayer.player2.play();
        }
    });

    $(window).on('videoBanner:vimeo:pause', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player) {
            currentPlayer.player.pause();
        }
    });

    $(window).on('videoBanner:vimeo:startSound', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player) {
            currentPlayer.player.setVolume(currentPlayer.prevVolume);
        }
    });

    $(window).on('videoBanner:vimeo:stopSound', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player) {
            currentPlayer.player.setVolume(0);
        }
    });

    $(window).on('videoBanner:vimeo:repeat', function (event, id) {
        let currentPlayer = players[id-1];

        if (currentPlayer && currentPlayer.player) {
            currentPlayer.player.setCurrentTime(currentPlayer.options.start);
        }
    });
}
